import LocomotiveScroll from "locomotive-scroll";
import gsap from "gsap";

const scroll = new LocomotiveScroll({
  el: document.querySelector("[data-scroll-container]"),
  smooth: true,
  tablet: {
    breakpoint: 0,
  },
  tablet: {
    breakpoint: 870,
    smooth: false,
  },
});

// Scroll update all pages

document.addEventListener("DOMContentLoaded", function () {
  function ScrollUpdateDelay() {
    setTimeout(function () {
      scroll.update();
    }, 200);
  }

  ScrollUpdateDelay();
});

function ScrollUpdateDelayGlobal() {
  setTimeout(function () {
    scroll.update();
  }, 300);
}



/**************** Menu Scroll ************/

const navBar = document.querySelector("nav");
const navItems = document.querySelectorAll(".menu-item a");
const logo1 = document.querySelectorAll(".logoFill-type");
const logo2 = document.querySelectorAll(".logoFill-txt");

if (window.matchMedia("(min-width: 870px)").matches) {

scroll.on("scroll", (position) => {
  if (position.scroll.y > 350) {
    navBar.classList.add("scrolldownNav");

    navItems.forEach((items) => {
      items.classList.add("scrolldownItems");
    });

    logo1.forEach((typesLogo) => {
      typesLogo.classList.add("scrolldownLogo1");
    });

    logo2.forEach((textsLogo) => {
      textsLogo.classList.add("scrolldownLogo2");
    });
  } else {
    navBar.classList.remove("scrolldownNav");

    navItems.forEach((items) => {
      items.classList.remove("scrolldownItems");
    });

    logo1.forEach((typesLogo) => {
      typesLogo.classList.remove("scrolldownLogo1");
    });

    logo2.forEach((textsLogo) => {
      textsLogo.classList.remove("scrolldownLogo2");
    });
  }
});
} else {

}

/****** Menu singles ********/

const menuSingle = document.querySelector(".single_header")

if(menuSingle){

  if (window.matchMedia("(min-width: 1025px)").matches) {

    scroll.on("scroll", (position) => {
      if (position.scroll.y > 0) {
        navBar.classList.add("scrolldownNav");
    
        navItems.forEach((items) => {
          items.classList.add("scrolldownItems");
        });
    
        logo1.forEach((typesLogo) => {
          typesLogo.classList.add("scrolldownLogo1");
        });
    
        logo2.forEach((textsLogo) => {
          textsLogo.classList.add("scrolldownLogo2");
        });
      } else {
        navBar.classList.add("scrolldownNav");
    
        navItems.forEach((items) => {
          items.classList.add("scrolldownItems");
        });
    
        logo1.forEach((typesLogo) => {
          typesLogo.classList.add("scrolldownLogo1");
        });
    
        logo2.forEach((textsLogo) => {
          textsLogo.classList.add("scrolldownLogo2");
        });
      }
    });
    }


}
 
/******* Scroll to HP hero -> section *******/

const scrollBtn = document.querySelector(".scroll-btn");
const hpCheck = document.querySelector(".hp__hero");

if (hpCheck) {
  scrollBtn.addEventListener("click", () => {
    scroll.scrollTo("#scrollHp", { offset: -130 });
  });
}

/******* Pannels animation 1200 to 100% *******/

scroll.on("scroll", (args) => {
  // Get all current elements : args.currentElements
  if (typeof args.currentElements["hpPannel1"] === "object") {

    const hpPannel1Left = document.querySelector(".pannel-left1");
    const hpPannel1Right = document.querySelector(".pannel-right1");

    hpPannel1Left.classList.add("scrollAnime");
    hpPannel1Right.classList.add("scrollAnime");

  } else if (typeof args.currentElements["hpPannel2"] === "object") {

    const hpPannel2Left = document.querySelector(".pannel-left2");
    const hpPannel2Right = document.querySelector(".pannel-right2");

    hpPannel2Left.classList.add("scrollAnime");
    hpPannel2Right.classList.add("scrollAnime");
  } else if (typeof args.currentElements["hpPannel3"] === "object") {

    const hpPannel4Left = document.querySelector(".pannel-left2");
    const hpPannel4Right = document.querySelector(".pannel-right2");

    hpPannel4Left.classList.add("scrollAnime");
    hpPannel4Right.classList.add("scrollAnime");
  } 
});

/************  Dropdown ******************/

function dropDown() {
  const allPannelImg = document.querySelectorAll('.visible-pannel img')
  const allPannel = document.querySelectorAll('.visible-pannel')

  allPannel.forEach(element => {

      element.addEventListener('click', function() {

          const heightPannel = this.parentNode.childNodes[3].scrollHeight;

          const currentChoice = this.parentNode.childNodes[3];

          const testImg = this.childNodes[3];

          if (testImg.src.includes('down')) {
              testImg.src = 'https://fovea-vet.fr/wp-content/themes/fovea/assets/svg/dropArrow-up.svg';

              element.classList.add('active-pannel');

              gsap.to(currentChoice, {
                  duration: 0.2,
                  height: heightPannel + 45,
                  padding: '20px 15px',
                  marginBottom: '30px'
              });
              gsap.to(currentChoice, {
                  duration: 0.4,
                  opacity: 1
              });



          } else if (testImg.src.includes('up')) {
              testImg.src = 'https://fovea-vet.fr/wp-content/themes/fovea/assets/svg/dropArrow-down.svg';

              element.classList.remove('active-pannel');

              gsap.to(currentChoice, {
                  duration: 0.2,
                  opacity: 0,
              });
              gsap.to(currentChoice, {
                  duration: 0.4,
                  height: 0,
                  padding: '0px 15px'
              });

            
          }

          function timeFunction() {
            setTimeout(function(){ scroll.update(); }, 500);
          }
          timeFunction();
      })

  })

};

const dropPage = document.querySelector('.single__clinique__equipement_wrapper');
const cliniquePage = document.querySelector('.cliniques__hero');
const recrutPage = document.querySelector('.recrut__hero');

if(dropPage){
  dropDown();

  const firstPannelOn = document.querySelector(".visible-pannel:first-child");
  const firstPannelBloc = document.querySelector(".toggle-pannel");

  document.getElementById("pannelImgFirst").src="https://fovea-vet.fr/wp-content/themes/fovea/assets/svg/dropArrow-up.svg";

  firstPannelOn.classList.add("active-pannel");
  firstPannelBloc.classList.add("first-pannel");


}
if (hpCheck || cliniquePage || recrutPage) {
  dropDown();
}


const formPage = document.querySelector('.form__container');

if(formPage){

 

  const btnPresentation = document.querySelector('.form--drop--presentation');
  const btnPlaquette = document.querySelector('.form--drop--plaquette');

  const formWrapper = document.querySelector('.form_display_wrapper');
  const formPlaquette = document.querySelector('.form_display--cf7Wrapper--plaquette');
  const formPresentation = document.querySelector('.form_display--cf7Wrapper--presentation');

  btnPlaquette.addEventListener('click', () => {

    const TLplaquette = gsap.timeline();

    TLplaquette
  
        .to(formWrapper, {opacity:1, display: "flex", duration:0.3, onComplete: 
          function() {
            
            formPresentation.classList.remove('open-form');
            formPlaquette.classList.add('open-form');
            scroll.update();
          
          }
        })

  })

  btnPresentation.addEventListener('click', () => {
    
    const TLpresentation = gsap.timeline();

    TLpresentation
  
        .to(formWrapper, {opacity:1, display: "flex", duration:0.3, onComplete: 
          function() {
            
            formPlaquette.classList.remove('open-form');
            formPresentation.classList.add('open-form');
            scroll.update();
          
          }
        })

  })
  
}

/******* Single Clinique -> scroll to *******/

const singleCliniquePage = document.querySelector(".single__section.single__clinique");


if (singleCliniquePage) {

  const anchor1 = document.querySelector(".anchor1");
  const anchor2 = document.querySelector(".anchor2");
  const anchor3 = document.querySelector(".anchor3");
  const anchor4 = document.querySelector(".anchor4");
  const anchor5 = document.querySelector(".anchor5");
  const anchor6 = document.querySelector(".anchor6");
  const anchor7 = document.querySelector(".anchor7");

  const allAnchor = document.querySelectorAll('.anchor');

  anchor1.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor1.classList.add('anchor-active');
    scroll.scrollTo("#presentation", { offset: -130 });

  });

  anchor2.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor2.classList.add('anchor-active');
    scroll.scrollTo("#urgence", { offset: -130 });

  });

  anchor3.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor3.classList.add('anchor-active');
    scroll.scrollTo("#equip", { offset: -130 });

  });
  
  anchor4.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor4.classList.add('anchor-active');
    scroll.scrollTo("#team", { offset: -130 });

  });
  
  anchor5.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor5.classList.add('anchor-active');
    scroll.scrollTo("#acces", { offset: -130 });

  });

  anchor6.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor6.classList.add('anchor-active');
    scroll.scrollTo("#acces", { offset: -130 });

  });
  anchor7.addEventListener("click", () => {
    
    allAnchor.forEach((anchors) => {
      anchors.classList.remove('anchor-active');
    })
    anchor7.classList.add('anchor-active');
    scroll.scrollTo("#equip2", { offset: -130 });

  });

  
}

// FAQ ***********************//

const faqPage = document.querySelector(".contact__faq");

if (faqPage) {
  const faq1 = document.querySelector(".faq1");
  const faq2 = document.querySelector(".faq2");
  const faq3 = document.querySelector(".faq3");
  const faq4 = document.querySelector(".faq4");

  const reponse1 = document.querySelector(".reponse1");
  const reponse2 = document.querySelector(".reponse2");
  const reponse3 = document.querySelector(".reponse3");
  const reponse4 = document.querySelector(".reponse4");

  const openFaq = document.querySelector(".contact__faq__display__reponse_wrapper");

  

  faq1.addEventListener("click", () => {
    faq2.classList.remove("active--faq");
    faq3.classList.remove("active--faq");
    faq4.classList.remove("active--faq");
    faq1.classList.toggle("active--faq");

    reponse2.classList.remove("faq--reponse--active");
    reponse3.classList.remove("faq--reponse--active");
    reponse4.classList.remove("faq--reponse--active");
    reponse1.classList.toggle("faq--reponse--active");

    const activeRep = document.querySelector(".faq--reponse--active");

    openFaq.classList.add("openFaq")
    if(!activeRep){
      openFaq.classList.remove("openFaq")
    }
    ScrollUpdateDelayGlobal()


  });
  faq2.addEventListener("click", () => {
    faq1.classList.remove("active--faq");
    faq3.classList.remove("active--faq");
    faq4.classList.remove("active--faq");
    faq2.classList.toggle("active--faq");

    reponse1.classList.remove("faq--reponse--active");
    reponse3.classList.remove("faq--reponse--active");
    reponse4.classList.remove("faq--reponse--active");
    reponse2.classList.toggle("faq--reponse--active");

    const activeRep = document.querySelector(".faq--reponse--active");

    openFaq.classList.add("openFaq")
    if(!activeRep){
      openFaq.classList.remove("openFaq")
    }
    ScrollUpdateDelayGlobal()
  });
  faq3.addEventListener("click", () => {
    faq1.classList.remove("active--faq");
    faq2.classList.remove("active--faq");
    faq4.classList.remove("active--faq");
    faq3.classList.toggle("active--faq");

    reponse1.classList.remove("faq--reponse--active");
    reponse2.classList.remove("faq--reponse--active");
    reponse4.classList.remove("faq--reponse--active");
    reponse3.classList.toggle("faq--reponse--active");

    const activeRep = document.querySelector(".faq--reponse--active");

    openFaq.classList.add("openFaq")
    if(!activeRep){
      openFaq.classList.remove("openFaq")
    }
    ScrollUpdateDelayGlobal()
  });
  faq4.addEventListener("click", () => {
    faq1.classList.remove("active--faq");
    faq2.classList.remove("active--faq");
    faq3.classList.remove("active--faq");
    faq4.classList.toggle("active--faq");

    reponse1.classList.remove("faq--reponse--active");
    reponse2.classList.remove("faq--reponse--active");
    reponse3.classList.remove("faq--reponse--active");
    reponse4.classList.toggle("faq--reponse--active");

    const activeRep = document.querySelector(".faq--reponse--active");

    openFaq.classList.add("openFaq")
    if(!activeRep){
      openFaq.classList.remove("openFaq")
    } 
    ScrollUpdateDelayGlobal()
  });
}


/******************* FILETER SEARCH ACTUS ************************/


const customSelectActus = document.querySelector(".searchebar__actus");

if (customSelectActus) {
  const filterValueSpe = document.querySelector(".select-css");
  const filterValueLieu = document.querySelector(".select-css.select-css2");

  // Arrow rotate on click
  const arrowSearch = document.querySelector(".searchArrow");
  const arrowSearch2 = document.querySelector(".searchArrow2");
  const arrowArea = document.querySelector(".optionsSearch1");
  const arrowArea2 = document.querySelector(".optionsSearch2");

  filterValueSpe.addEventListener("click", () => {
    arrowSearch.classList.add("searchArrowOn");
  });
  arrowArea.addEventListener("mouseleave", function () {
    arrowSearch.classList.remove("searchArrowOn");
  });

  filterValueLieu.addEventListener("click", () => {
    arrowSearch2.classList.add("searchArrowOn");
  });
  arrowArea2.addEventListener("mouseleave", function () {
    arrowSearch2.classList.remove("searchArrowOn");
  });
  // END Arrow

  const btnFilter = document.querySelector("button");

  btnFilter.addEventListener("click", () => {
    if (btnFilter.classList.value !== "all") {
      var filterValueEnd2 = filterValueLieu.value;
      var filterValueEnd = filterValueSpe.value;

      if (filterValueEnd === "") {
        filterValueEnd = "all";
      }
      if (filterValueEnd2 === "") {
        filterValueEnd2 = "all";
      }

      btnFilter.classList = "";

      if (filterValueEnd === "all") {
        btnFilter.classList.add(filterValueEnd2);
        
      } else if (filterValueEnd2 === "all") {
        btnFilter.classList.add(filterValueEnd);
      }

      const allCards = document.querySelectorAll(".actus__actus--card");

      allCards.forEach((cards) => {
       

        if (btnFilter.classList.value != "all") {
          cards.classList.remove("onView");
          if (cards.classList.contains(btnFilter.classList.value)) {
            cards.classList.add("actus__actus--card", "onView");
          }
        }
      });
    } else {
    }
    ScrollUpdateDelayGlobal(); 
  });

  const newOrder = document.querySelector(".new");
  const oldOrder = document.querySelector(".old");

  newOrder.addEventListener("click", () => {
    btnFilter.dataset.order = "new";
  });
  oldOrder.addEventListener("click", () => {
    btnFilter.dataset.order = "old";
 
  });

  btnFilter.addEventListener("click", () => {

    const newFinal = document.querySelector(`button[data-order="new"]`);
    const oldFinal = document.querySelector(`button[data-order="old"]`);

    if (newFinal) {
    
      window.location.href = "?orderby=date&order=DESC";
    } else if (oldFinal) {
 
      window.location.href = "?orderby=date&order=ASC";
    }
  });
}

/************************* FILETER SEARCH RECRUT  ****************************/

// Filter with select and BTN **Isotope**

const customSelectRecrut = document.querySelector(".searchebar__recrut");

if (customSelectRecrut) {


  const filterValueSpe = document.querySelector(".select-css");
  const filterValueLieu = document.querySelector(".select-css.select-css2");

    // Arrow rotate on click
    const arrowSearch = document.querySelector(".searchArrow");
    const arrowSearch2 = document.querySelector(".searchArrow2");
    const arrowArea = document.querySelector(".optionsSearch1");
    const arrowArea2 = document.querySelector(".optionsSearch2");
  
    filterValueSpe.addEventListener("click", () => {
      arrowSearch.classList.add("searchArrowOn");
    });
    arrowArea.addEventListener("mouseleave", function () {
      arrowSearch.classList.remove("searchArrowOn");
    });
  
    filterValueLieu.addEventListener("click", () => {
      arrowSearch2.classList.add("searchArrowOn");
    });
    arrowArea2.addEventListener("mouseleave", function () {
      arrowSearch2.classList.remove("searchArrowOn");
    });
    // END Arrow

  const btnFilter = document.querySelector("button");

  btnFilter.addEventListener("click", () => {
    if (btnFilter.classList.value !== "all") {
      var filterValueEnd2 = filterValueLieu.value;
      var filterValueEnd = filterValueSpe.value;

      if (filterValueEnd === "") {
        filterValueEnd = "all";
      }
      if (filterValueEnd2 === "") {
        filterValueEnd2 = "all";
      }

      btnFilter.classList = "";

      if (filterValueEnd === "all") {
        btnFilter.classList.add(filterValueEnd2);
        
      } else if (filterValueEnd2 === "all") {
        btnFilter.classList.add(filterValueEnd);
      }

      const allCards = document.querySelectorAll(".filterCard")

      allCards.forEach(cards => {

   

        if(btnFilter.classList.value != "all"){
        cards.classList.remove("onView")
        if(cards.classList.contains(btnFilter.classList.value)){
          cards.classList.add("filterCard","onView")
        } }
      })


    } else {
    }
    ScrollUpdateDelayGlobal(); 
  });


}


// Formulaire annonce recrut


const pageAnnonce = document.querySelector('.form__recrut__wrapper');
const hiddenTitleAnnonce = document.querySelector('.js-form');
const btnSIngleLeft = document.querySelector('.single_recrut--btn');
const btnSIngleRight = document.querySelector('.right-form-btn');
const annonceTitle = document.querySelector('.bread_container p')

if(pageAnnonce) {

  btnSIngleLeft.addEventListener('click', () => {

   
    scroll.scrollTo("#form-recrut", { offset: -150 });
   
    hiddenTitleAnnonce.value = annonceTitle.innerText;
    pageAnnonce.classList.add('active-form')
    ScrollUpdateDelayGlobal()

  })

  btnSIngleRight.addEventListener('click', () => {

    scroll.scrollTo("#form-recrut", { offset: -150 });

    hiddenTitleAnnonce.value = annonceTitle.innerText;
    pageAnnonce.classList.add('active-form')
    ScrollUpdateDelayGlobal()

  })
}